import Cookies from "js-cookie";
import { Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

import AccountProfile from "../views/cloud/account/AccountProfile";
import AccountSecurity from "../views/cloud/account/AccountSecurity";
import AccountClouds from "../views/cloud/account/AccountClouds";
import AppNavbar from "../components/AppNavbar/AppNavbar";
import AppPageHeader from "../components/Headers/AppPageHeader";
import AppHelmet from "../components/AppComponents/AppHelmet";

const accountTabs = [
  { title: "Profile", activeValue: "profile" },
  { title: "Security & Access", activeValue: "security" },
  { title: "Clouds", activeValue: "clouds" },
];

function AccountLayout({ backArrow = false }) {
  const navigate = useNavigate();
  const { tab, tenantID } = useParams();

  const baseURL = tenantID ? `/clouds/${tenantID}/settings/` : "/";

  const handleTabChange = (val: string) =>
    navigate(`${baseURL}account/${val}`, { replace: true });

  useEffect(() => {
    if (!Cookies.get("authenticationToken")) return;

    if (!accountTabs.map((v) => v.activeValue).includes(tab ?? "")) {
      navigate(`${baseURL}profile`);
    }
  }, []);

  return (
    <>
      <AppHelmet title="Account Settings - GrowthCloud.com" />
      <div className="px-4">
        {backArrow && (
          <Button
            outline
            className="mt-1"
            size="sm"
            onClick={() => navigate("/clouds")}
          >
            <i className="mdi mdi-arrow-left" />
            <span className="btn-inner--text">Back</span>
          </Button>
        )}
        <div className="d-flex align-items-center">
          <AppPageHeader
            title="Account Settings"
            description="Manage your GrowthCloud profile information & account settings"
            borderless={true}
          />
        </div>
        <div className="mt--4 mb-3">
          <AppNavbar
            tabs={accountTabs}
            activeTab={tab}
            onSelect={handleTabChange}
          />
        </div>
      </div>
      {tab === "profile" && <AccountProfile tenantID={tenantID} />}
      {tab === "security" && <AccountSecurity />}
      {tab === "clouds" && <AccountClouds />}
    </>
  );
}

export default AccountLayout;
